/// <reference path="./Entity.ts" />
/// <reference path="../HTML/Tag.ts" />
namespace HA.Core.Entity {
    import Tag = HA.Core.HTML.Tag;
    export class AppMenu extends Entity {

        /**
         *
         * @returns {Map<any, any>}
         */
        public getInfo() {
            return this.getTag().getAttributes(["appName", "appIcon"]);
        }

        /**
         *
         * @param controller
         * @returns {Map<String, any>}
         */
        protected setController(controller: any) {
            return this.addToData("controller", controller);
        }

        /**
         *
         * @returns {any}
         */
        protected getController() {
            return this.get("controller");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addToData("cachable", false);
            this.addToData("tag", new Tag(data));
            const controllerName = this.get("controllerName");
            if (controllerName) {
                const controllerNamespace = this.getControllerNamespace(this.get("controllerNamespace")),
                    cdata = toMap(this.getData());
                this.setController(createService(controllerNamespace, controllerName, cdata));
            }
        }

        /**
         *
         * @param name
         * @returns {any}
         */
        protected getControllerNamespace(name: string) {
            let n: any;
            switch (name) {
                case "HA.Core.Controller.Navigation" :
                    n = HA.Core.Controller.Navigation;
                    break;
                case "HA.Core.Controller.Menu" :
                    n = HA.Core.Controller.Menu;
                    break;
                case "HA.Core.Controller.Page" :
                    n = HA.Core.Controller.Page;
                    break;
                default :
                    n = HA.Core.Controller.Menu;
                    break;
            }

            return n;
        }
    }
}
